import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';
import { getSelectedTabFromUrl } from 'common/utils/utils';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import TabList from 'components/TabList';
import useSettingsService from 'components/hooks/useSettingsService';

const ActivityTabs = () => {
  const history = useHistory();
  const { getSettingOrDefinitionValue } = useSettingsService();
  const isActivityReleasesEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isActivityReleasesEnabled
  });

  const onTabClick = ({ path }) => history.push(path);

  const tabs = [
    { name: 'Branches', path: AppRouter.BRANCH.path, type: 'default' },
    { name: 'Pull Requests', path: AppRouter.PULL_REQUESTS.path }
  ];

  if (isActivityReleasesEnabled) {
    tabs.push({ name: 'Releases', path: AppRouter.RELEASES.path });
  }
  tabs.push({ name: 'Incidents', path: AppRouter.INCIDENTS.path });

  const selectedTab = getSelectedTabFromUrl(tabs, history);

  return (
    <TabList
      enableSelected={false}
      tabs={tabs}
      onTabClick={onTabClick}
      selectedTab={selectedTab ? selectedTab.name : ''}
    />
  );
};

export default ActivityTabs;
